// ─── Features ────────────────────────────────────────────────────────────────
export const FEATURES = [
  { i:"globe", c:"",  t:"Sito di prenotazione incluso",  d:"Il tuo noleggio ha subito un sito professionale dove i clienti vedono i veicoli disponibili e prenotano online. Zero web designer." },
  { i:"car",   c:"",  t:"Gestione auto e moto",          d:"Catalogo separato per auto e moto. Categorie, prezzi giornalieri, foto gallery e disponibilità in tempo reale." },
  { i:"credit",c:"",  t:"Pagamenti online Stripe",       d:"Accetta carte di credito direttamente sul tuo sito. Integrazione Stripe nativa, sicura e conforme PCI DSS." },
  { i:"cal",   c:"g", t:"Calendario disponibilità",      d:"I clienti vedono giorni liberi e occupati. Blocco automatico dei periodi già prenotati in tempo reale." },
  { i:"pdf",   c:"g", t:"Contratti PDF automatici",      d:"Genera il contratto di noleggio in PDF con dati azienda, cliente e veicolo. Un click dal pannello admin." },
  { i:"chart", c:"g", t:"Statistiche e ricavi",          d:"Dashboard con ricavi mensili, veicolo più noleggiato, prenotazioni per categoria, split online/cassa." },
  { i:"tag",   c:"a", t:"Codici sconto",                 d:"Crea promozioni con sconto percentuale o fisso, limite utilizzi, date di validità e importo minimo." },
  { i:"users", c:"a", t:"Multi-admin e clienti",         d:"Aggiungi più operatori al pannello. I clienti si registrano, accedono con Google e vedono tutta la loro storia." },
  { i:"shield",c:"a", t:"100% cloud, zero server",       d:"Nessuna installazione, nessun aggiornamento. Funziona da qualsiasi browser su PC, tablet e smartphone." },
  { i:"lock",  c:"a", t:"Comunicazione CaRGOS alla Questura", d:"Alla consegna del veicolo, il contratto viene trasmesso in automatico al portale CaRGOS della Polizia di Stato, con credenziali verificate prima dell'invio." },
];

// ─── Steps ───────────────────────────────────────────────────────────────────
export const STEPS = [
  { n:"1", t:"Attivi il tuo spazio",     d:"Registri la tua azienda, inserisci i dati e carichi il logo. Meno di 15 minuti per configurare tutto." },
  { n:"2", t:"Aggiungi i veicoli",        d:"Crei la scheda di ogni veicolo con foto, categoria, prezzi per giorno della settimana e disponibilità." },
  { n:"3", t:"Condividi il link",         d:"Il sito di prenotazione è subito online. Lo metti su Instagram, Google Business o lo mandi via WhatsApp." },
  { n:"4", t:"Gestisci le prenotazioni",  d:"Ricevi prenotazioni, conferma ritiri, stampa contratti e consulta le statistiche dal pannello admin." },
];

// ─── Testimonials ─────────────────────────────────────────────────────────────
export const TESTIMONIALS = [
  { n:"Marco Esposito", r:"Autonoleggio — Napoli",  i:"ME", q:"Prima gestivo tutto con Excel e WhatsApp. Adesso i clienti prenotano da soli, io ricevo la notifica e stampo il contratto in un click. Mi ha cambiato il lavoro." },
  { n:"Giulia Ferrara",  r:"Motonoleggio — Rimini",  i:"GF", q:"In estate gestisco 40 moto. Non perdo più una prenotazione e i pagamenti arrivano direttamente sul conto. Il Business Pro è stato la scelta giusta." },
  { n:"Salvatore Arena", r:"Autonoleggio — Palermo", i:"SA", q:"Il sito di prenotazione è professionale. I clienti si fidano di più e ho aumentato le prenotazioni del 35% in tre mesi." },
];

// ─── FAQ ──────────────────────────────────────────────────────────────────────
export const FAQS = [
  { q:"Cos'è NoleggioinCloud?",                       a:"NoleggioinCloud è un gestionale cloud per autonoleggi e motonoleggi che include un sito di prenotazione online già pronto per i tuoi clienti. Nessun programmatore, nessun web designer: sei operativo in meno di un'ora." },
  { q:"Come funziona la prova gratuita?",              a:"Hai 14 giorni di prova con le funzionalità principali incluse (fino a 40 veicoli, statistiche avanzate, codici sconto, admin illimitati), senza carta di credito. Dominio personalizzato, hosting dedicato e personalizzazione del sito sono disponibili solo attivando il piano Business Pro. Al termine dei 14 giorni, ti chiediamo di scegliere tra Base, Pro o Business Pro. I tuoi dati e le tue configurazioni rimangono al sicuro." },
  { q:"Qual è la differenza tra Pro e Business Pro?",  a:"Il piano Pro (€89,99/mese) include sia auto che moto ma non comprende dominio personalizzato né hosting né personalizzazione del sito: il sito è raggiungibile all'indirizzo noleggioincloud.app/nome-del-tuo-noleggio. Il Business Pro (€169/mese) include dominio personalizzato, hosting e personalizzazione completa del sito, con SLA garantito al 99.95%. L'assistenza via email e chat WhatsApp è la stessa su tutti i piani." },
  { q:"Il piano Pro include dominio e hosting?",       a:"No. Il piano Pro non include dominio personalizzato né hosting. Il sito di prenotazione funziona all'indirizzo noleggioincloud.app/nome-del-tuo-noleggio. Per avere un dominio proprio (es. tuonoleggio.it) e hosting dedicato serve il Business Pro." },
  { q:"Posso personalizzare il sito con il piano Pro?",  a:"No. La personalizzazione completa del sito (logo, colori, dominio e brand) è disponibile esclusivamente nel piano Business Pro." },
  { q:"Posso cambiare piano in seguito?",              a:"Sì, puoi fare upgrade o downgrade in qualsiasi momento. Se passi al piano superiore, paghi solo la differenza proporzionale ai giorni rimanenti del mese." },
  { q:"I pagamenti online come funzionano?",           a:"Integrazione nativa con Stripe. I clienti pagano con carta direttamente sul tuo sito. I fondi arrivano sul tuo conto entro 2-7 giorni lavorativi. Puoi anche abilitare pagamento contanti o bonifico." },
  { q:"Posso personalizzare il sito di prenotazione?", a:"Sì. Configuri logo, nome azienda, testi dei popup, termini e condizioni, messaggio di conferma prenotazione e orari dal pannello impostazioni. La personalizzazione avanzata con colori del brand e tema grafico dedicato è disponibile nel piano Business Pro." },
  { q:"Come vengono generati i contratti PDF?",        a:"Automaticamente ad ogni prenotazione. Il PDF include i tuoi dati aziendali, quelli del cliente, il veicolo, il periodo noleggio, il prezzo e le condizioni che hai impostato." },
  { q:"Devo installare qualcosa?",                     a:"No. NoleggioinCloud è 100% cloud. Funziona da qualsiasi browser su PC, tablet e smartphone. Nessun server da gestire, tutto aggiornato automaticamente." },
];

// ─── Compare table ────────────────────────────────────────────────────────────
export const COMPARE = [
  { f:"Sito prenotazioni online",          free:true,          base:true,         pro:true,          biz:true        },
  { f:"Durata accesso",                    free:"14 giorni",   base:"Illimitato",  pro:"Illimitato",  biz:"Illimitato"},
  { f:"Gestione Auto",                     free:true,          base:true,         pro:true,          biz:true        },
  { f:"Gestione Moto",                     free:true,          base:true,         pro:true,          biz:true        },
  { f:"Pagamenti online Stripe",           free:true,          base:true,         pro:true,          biz:true        },
  { f:"Contratti PDF automatici",          free:true,          base:true,         pro:true,          biz:true        },
  { f:"Codici sconto",                     free:true,          base:false,        pro:true,          biz:true        },
  { f:"Statistiche avanzate",              free:true,          base:false,        pro:true,          biz:true        },
  { f:"Veicoli caricabili",                free:"40",          base:"10",         pro:"40",          biz:"Illimitati"},
  { f:"Database incluso",                 free:"5 GB",        base:"2 GB",       pro:"5 GB",        biz:"10 GB"     },
  { f:"Addon +5 GB archiviazione",        free:"incluso",     base:"+5€/mese",   pro:"+5€/mese",    biz:"+5€/mese"  },
  { f:"Admin",                             free:"Illimitati",  base:"1",          pro:"Illimitati",  biz:"Illimitati"},
  { f:"Onboarding assistito",              free:true,          base:false,        pro:true,          biz:true        },
  { f:"Dominio personalizzato incluso",    free:false,         base:false,        pro:false,         biz:true        },
  { f:"Hosting incluso",                   free:false,         base:false,        pro:false,         biz:true        },
  { f:"Personalizzazione sito (logo, colori, brand)", free:false, base:false,     pro:false,         biz:true        },
  { f:"Assistenza",                        free:"Email e WhatsApp", base:"Email e WhatsApp", pro:"Email e WhatsApp", biz:"Email e WhatsApp" },
  { f:"SLA garantito",                     free:false,         base:false,        pro:"99.90%",      biz:"99.95%"   },
];

// ─── Nav labels ───────────────────────────────────────────────────────────────
export const LABEL = {
  home:"Home",
  "funzionalita":"Funzionalità",
  "come-funziona":"Come Funziona",
  prezzi:"Prezzi",
  tutorial:"Tutorial",
  faq:"FAQ",
  contatti:"Contatti",
  cerca:"Trova un noleggio",
};
export const PAGES_NAV = ["funzionalita","come-funziona","prezzi","tutorial","faq","contatti","cerca"];

// ─── JSON-LD ──────────────────────────────────────────────────────────────────
export const SCHEMA = {
  "@context":"https://schema.org",
  "@type":"SoftwareApplication",
  "name":"NoleggioinCloud",
  "applicationCategory":"BusinessApplication",
  "operatingSystem":"Web",
  "description":"Gestionale cloud per autonoleggi e motonoleggi che ti genera un sito web per far prenotare e pagare i tuoi clienti tutto online. Prova gratuita 14 giorni.",
  "offers":[
    { "@type":"Offer","name":"Prova Gratuita","price":"0","priceCurrency":"EUR","description":"14 giorni di prova gratuita, nessuna carta di credito richiesta" },
    { "@type":"Offer","name":"Base","price":"34.99","priceCurrency":"EUR","description":"Fino a 10 veicoli, Auto e Moto incluse, sito prenotazioni, Stripe e contratti PDF." },
    { "@type":"Offer","name":"Pro","price":"89.99","priceCurrency":"EUR","description":"Fino a 40 veicoli, Auto e Moto incluse. Assistenza via email e chat WhatsApp. SLA 99.90%. Senza dominio e hosting." },
    { "@type":"Offer","name":"Business Pro","price":"169","priceCurrency":"EUR","description":"Veicoli illimitati, dominio personalizzato, hosting e personalizzazione del sito inclusi. Assistenza prioritaria via email e chat WhatsApp. SLA 99.95%." },
  ],
};

// ─── Site URL ─────────────────────────────────────────────────────────────────
export const SITE_URL = "https://www.noleggioincloud.app";

// ─── Per-page SEO metadata ────────────────────────────────────────────────────
export const PAGE_SEO = {
  home: {
    title: "NoleggioinCloud: Gestionale Noleggio Auto e Moto",
    description: "Gestionale per autonoleggi e motonoleggi con sito web incluso: i clienti prenotano e pagano online. Contratti PDF e CaRGOS. Prova gratuita di 14 giorni.",
    path: "/",
  },
  funzionalita: {
    title: "Funzionalità del gestionale noleggio | NoleggioinCloud",
    description: "Sito prenotazioni online, calendario in tempo reale, pagamenti Stripe, contratti PDF automatici, statistiche ricavi, codici sconto e admin illimitati.",
    path: "/funzionalita",
  },
  "come-funziona": {
    title: "Come funziona — Inizia in meno di un'ora | NoleggioinCloud",
    description: "Registra la tua azienda, aggiungi i veicoli, condividi il link e gestisci le prenotazioni. Operativo in meno di un'ora, senza programmatori né web designer.",
    path: "/come-funziona",
  },
  prezzi: {
    title: "Prezzi gestionale noleggio da €34,99 | NoleggioinCloud",
    description: "Base €34,99/mese, Pro €89,99/mese, Business Pro €169/mese con dominio e hosting. Prova gratuita 14 giorni senza carta di credito. Cambi piano quando vuoi.",
    path: "/prezzi",
  },
  faq: {
    title: "FAQ gestionale noleggio auto e moto | NoleggioinCloud",
    description: "Risposte alle domande più frequenti: prova gratuita, differenze tra piani, pagamenti Stripe, contratti PDF, personalizzazione app, dominio e hosting inclusi.",
    path: "/faq",
  },
  "chi-siamo": {
    title: "Chi siamo | NoleggioinCloud",
    description: "NoleggioinCloud è il gestionale cloud per autonoleggi e motonoleggi italiani: prenotazioni online, contratti PDF, pagamenti Stripe e comunicazione CaRGOS.",
    path: "/chi-siamo",
  },
  contatti: {
    title: "Contatti e demo gratuita — NoleggioinCloud",
    description: "Contatta il team di NoleggioinCloud per informazioni o una demo gratuita. Chiamaci o scrivici su WhatsApp al +39 3516234175. Risposta entro 24 ore lavorative.",
    path: "/contatti",
  },
  tutorial: {
    title: "Tutorial video — Come usare NoleggioinCloud",
    description: "Guide video passo passo per imparare a usare NoleggioinCloud: configurazione iniziale, gestione veicoli, prenotazioni, contratti PDF e pagamenti Stripe.",
    path: "/tutorial",
  },
  "quando-serve-un-gestionale-per-autonoleggio": {
    title: "Quando serve un gestionale autonoleggio | NoleggioinCloud",
    description: "I segnali che Excel e WhatsApp non bastano più: doppie prenotazioni, contratti scritti a mano, nessuna statistica. Quando passare a un gestionale.",
    path: "/quando-serve-un-gestionale-per-autonoleggio",
  },
  "quanto-costa-un-gestionale-per-autonoleggio": {
    title: "Quanto costa un gestionale autonoleggio | NoleggioinCloud",
    description: "Prezzi, voci di costo nascoste e cosa confrontare prima di scegliere un software gestionale per autonoleggio o motonoleggio. Guida ai costi reali 2026.",
    path: "/quanto-costa-un-gestionale-per-autonoleggio",
  },
  "come-scegliere-gestionale-autonoleggio": {
    title: "Come scegliere un gestionale autonoleggio | NoleggioinCloud",
    description: "Le 7 funzionalità da controllare prima di scegliere un gestionale per noleggio auto o moto: sito incluso, pagamenti, contratti, disponibilità, assistenza.",
    path: "/come-scegliere-gestionale-autonoleggio",
  },
  "gestionale-noleggio-moto": {
    title: "Gestionale noleggio moto: cosa cambia | NoleggioinCloud",
    description: "Patenti, caschi e dispositivi, cauzioni, stagionalità: le differenze da considerare in un gestionale pensato anche per il noleggio di moto e scooter.",
    path: "/gestionale-noleggio-moto",
  },
  "come-evitare-doppie-prenotazioni-autonoleggio": {
    title: "Come evitare le doppie prenotazioni | NoleggioinCloud",
    description: "Perché capita l'overbooking su un veicolo a noleggio e come un calendario condiviso in tempo reale lo elimina alla radice.",
    path: "/come-evitare-doppie-prenotazioni-autonoleggio",
  },
  "checklist-confronto-gestionali-autonoleggio": {
    title: "Checklist confronto gestionali noleggio | NoleggioinCloud",
    description: "La checklist pratica da usare durante una demo o un confronto tra fornitori, per non scoprire dopo aver firmato cosa non era incluso.",
    path: "/checklist-confronto-gestionali-autonoleggio",
  },
  "gestionale-noleggio-cargos-polizia": {
    title: "Gestionale noleggio con CaRGOS | NoleggioinCloud",
    description: "Invio dei contratti di noleggio auto a CaRGOS (Polizia di Stato, art. 17 D.L. 113/2018): credenziali verificate e comunicazione automatica alla consegna del veicolo.",
    path: "/gestionale-noleggio-cargos-polizia",
  },
  "excel-whatsapp-o-gestionale-autonoleggio": {
    title: "Excel e WhatsApp o gestionale noleggio | NoleggioinCloud",
    description: "Tabella di confronto diretto tra gestire un autonoleggio con Excel e WhatsApp e farlo con un gestionale dedicato, attività per attività.",
    path: "/excel-whatsapp-o-gestionale-autonoleggio",
  },
};

// ─── Guide / contenuti editoriali (per link interni in footer e tra articoli) ─
export const GUIDES = [
  { slug: "quando-serve-un-gestionale-per-autonoleggio", label: "Quando serve un gestionale" },
  { slug: "quanto-costa-un-gestionale-per-autonoleggio",  label: "Quanto costa un gestionale" },
  { slug: "come-scegliere-gestionale-autonoleggio",       label: "Come scegliere il gestionale" },
  { slug: "gestionale-noleggio-cargos-polizia",          label: "Gestionale con CaRGOS e Polizia" },
  { slug: "gestionale-noleggio-moto",                      label: "Gestionale per il noleggio moto" },
  { slug: "come-evitare-doppie-prenotazioni-autonoleggio", label: "Evitare le doppie prenotazioni" },
  { slug: "checklist-confronto-gestionali-autonoleggio",   label: "Checklist confronto gestionali" },
  { slug: "excel-whatsapp-o-gestionale-autonoleggio",      label: "Excel/WhatsApp o gestionale" },
];

// ─── JSON-LD Schemas ──────────────────────────────────────────────────────────

// Home: SoftwareApplication + Organization + WebSite
// Dati societari per la pagina "Chi siamo" e lo schema Organization.
// Lasciali vuoti finché non li hai: i campi vuoti non vengono pubblicati.
export const COMPANY = {
  legalName: "",   // es. "Rossi Software S.r.l."
  vatId: "",       // es. "IT01234567890"
  street: "",      // es. "Via Roma 1"
  city: "",        // es. "Napoli"
  postalCode: "",  // es. "80100"
  region: "",      // es. "NA"
};

export const SCHEMA_HOME = [
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "NoleggioinCloud",
    "url": SITE_URL,
    "image": `${SITE_URL}/og-image.jpg`,
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web, iOS, Android",
    "description": "Gestionale cloud per autonoleggi e motonoleggi che ti genera un sito web per far prenotare e pagare i tuoi clienti tutto online. Pagamenti Stripe e contratti PDF automatici inclusi.",
    "inLanguage": "it",
    "offers": [
      { "@type":"Offer", "name":"Prova Gratuita", "price":"0",     "priceCurrency":"EUR", "description":"14 giorni di prova gratuita, nessuna carta di credito richiesta" },
      { "@type":"Offer", "name":"Base",           "price":"34.99", "priceCurrency":"EUR", "description":"Fino a 10 veicoli, Auto e Moto, senza dominio e hosting" },
      { "@type":"Offer", "name":"Pro",            "price":"89.99", "priceCurrency":"EUR", "description":"Fino a 40 veicoli, Auto e Moto, senza dominio e hosting" },
      { "@type":"Offer", "name":"Business Pro",   "price":"169",   "priceCurrency":"EUR", "description":"Veicoli illimitati, dominio personalizzato e hosting inclusi" },
    ],
    // Nota: aggregateRating/review rimossi volontariamente. Le linee guida
    // Google sui dati strutturati vietano review "self-serving" (raccolte e
    // pubblicate dalla stessa azienda che le mostra, senza una piattaforma
    // terza indipendente che le verifichi). Con soli 3 testimonial interni,
    // tenerle nello schema rischiava la soppressione del rich result o, nel
    // caso peggiore, di far ignorare a Google tutto il markup della pagina.
    // I testimonial restano visibili in pagina come contenuto normale (non
    // come dati strutturati) — se in futuro si raccolgono recensioni vere
    // su Google Business Profile o Trustpilot, si può reintrodurre lo schema
    // puntando a quella fonte esterna verificabile.
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "NoleggioinCloud",
    "alternateName": ["NoleggioInCloud", "Noleggio in Cloud", "Noleggio in Cloud gestionale"],
    "url": SITE_URL,
    "logo": `${SITE_URL}/logo-512.png`,
    "image": `${SITE_URL}/og-image.jpg`,
    "telephone": "+39-351-623-4175",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+39-351-623-4175",
      "contactType": "customer support",
      "availableLanguage": "Italian",
      "areaServed": "IT",
    },
    "areaServed": "IT",
    ...(COMPANY.legalName && { "legalName": COMPANY.legalName }),
    ...(COMPANY.vatId && { "vatID": COMPANY.vatId }),
    ...(COMPANY.street && COMPANY.city && {
      "address": {
        "@type": "PostalAddress",
        "streetAddress": COMPANY.street,
        "addressLocality": COMPANY.city,
        "postalCode": COMPANY.postalCode,
        "addressRegion": COMPANY.region,
        "addressCountry": "IT",
      },
    }),
    // Profili ufficiali: aiutano Google a collegare il brand al sito.
    // Aggiungi qui altri profili (Facebook, LinkedIn, YouTube, Google Business...).
    "sameAs": ["https://www.instagram.com/noleggioincloud.app/"],
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "NoleggioinCloud",
    "alternateName": ["NoleggioInCloud", "Noleggio in Cloud"],
    "url": SITE_URL,
    "inLanguage": "it",
  },
];

// Prezzi: SoftwareApplication con offerte (abbonamenti SaaS: niente spedizione né resi,
// che sono proprietà da Product fisico e non hanno senso per un software).
const priceValidUntil = `${new Date().getFullYear() + 1}-12-31`;
const offer = (name, price, description) => ({
  "@type": "Offer",
  "name": name,
  "price": price,
  "priceCurrency": "EUR",
  "priceValidUntil": priceValidUntil,
  "availability": "https://schema.org/InStock",
  "url": `${SITE_URL}/prezzi`,
  "description": description,
  "priceSpecification": {
    "@type": "UnitPriceSpecification",
    "price": price,
    "priceCurrency": "EUR",
    "billingDuration": "P1M",
    "unitCode": "MON",
  },
});

export const SCHEMA_PREZZI = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "NoleggioinCloud",
  "description": "Gestionale cloud per autonoleggi e motonoleggi italiani con sito prenotazioni, pagamenti Stripe, contratti PDF e comunicazione CaRGOS.",
  "image": `${SITE_URL}/og-image.jpg`,
  "url": `${SITE_URL}/prezzi`,
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "inLanguage": "it",
  "offers": [
    offer("Piano Base", "34.99", "Fino a 10 veicoli, Auto e Moto incluse, sito prenotazioni e contratti PDF, senza dominio personalizzato né hosting"),
    offer("Piano Pro", "89.99", "Auto e Moto incluse, fino a 40 veicoli, senza dominio personalizzato né hosting"),
    offer("Piano Business Pro", "169.00", "Veicoli illimitati, dominio personalizzato e hosting inclusi, assistenza prioritaria"),
  ],
  // Nota: aggregateRating rimosso volontariamente (stesso motivo del blocco
  // SoftwareApplication in SCHEMA_HOME): rating auto-pubblicati e non verificati
  // da una piattaforma terza violano le linee guida Google sui dati strutturati
  // e la Direttiva Omnibus. Reinserire solo con recensioni reali e verificabili.
};

// FAQ: FAQPage (appare direttamente nella SERP Google)
export const SCHEMA_FAQ = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": FAQS.map(f => ({
    "@type": "Question",
    "name": f.q,
    "acceptedAnswer": { "@type": "Answer", "text": f.a },
  })),
};

// BreadcrumbList helper
export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type":"ListItem", "position":1, "name":"Home", "item": SITE_URL },
    ...items.map((item, i) => ({
      "@type": "ListItem",
      "position": i + 2,
      "name": item.name,
      "item": `${SITE_URL}${item.path}`,
    })),
  ],
});

// ─── Partner / Tecnologie ────────────────────────────────────────────────────
// Aggiungi o rimuovi partner qui; l'ordine è quello visualizzato nella strip.
export const PARTNERS = [
  { key: "stripe",       name: "Stripe",           desc: "Pagamenti online"    },
  { key: "google",       name: "Google",            desc: "Mappe & Auth"        },
  { key: "firebase",     name: "Firebase",          desc: "Database & Cloud"    },
  { key: "cargos",       name: "Cargos",            desc: "Documenti di viaggio"},
  { key: "poliziaStato", name: "Polizia di Stato",  desc: "Verifica identità"   },
  { key: "pciDss",       name: "PCI DSS",           desc: "Pagamenti sicuri"    },
];

// Pre-built breadcrumbs for all pages
// Item "grezzi" (name+path), usati sia per lo schema JSON-LD BreadcrumbList
// sia per il breadcrumb HTML visibile <Breadcrumb items={...}/> in pagina:
// un'unica fonte, mai due liste da tenere allineate a mano.
export const BREADCRUMB_ITEMS = {
  funzionalita:    [{ name:"Funzionalità",  path:"/funzionalita"  }],
  "come-funziona": [{ name:"Come Funziona", path:"/come-funziona" }],
  prezzi:          [{ name:"Prezzi",        path:"/prezzi"        }],
  faq:             [{ name:"FAQ",           path:"/faq"           }],
  tutorial:        [{ name:"Tutorial",      path:"/tutorial"      }],
  contatti:        [{ name:"Contatti",      path:"/contatti"      }],
  "chi-siamo":     [{ name:"Chi siamo",     path:"/chi-siamo"     }],
};

export const BREADCRUMBS = Object.fromEntries(
  Object.entries(BREADCRUMB_ITEMS).map(([slug, items]) => [slug, breadcrumb(items)])
);
